<template>
  <div>
    <div
      v-for="activity in activities"
      :class="$style.activitiesListItemWrapper"
      :key="activity.id"
    >
      <activities-list-item
        :activity="activity"
      />
    </div>
  </div>
</template>

<script>
import ActivitiesListItem from './ActivitiesListItem'

export default {
  components: {
    ActivitiesListItem,
  },
  props: {
    activities: {
      required: true,
      type: Array,
    },
  },
}
</script>

<style lang="scss" module>
.activities-list {
  &__item-wrapper {
    @apply border rounded border-background-dark p-6 bg-background-lightest shadow-2;
  }
}
</style>



// WEBPACK FOOTER //
// src/server/components/Activities/FeaturedActivitiesList.vue